import React  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Folder2 from '../../../../../assets/svg/folder-2.svg';
import Folder1 from '../../../../../assets/svg/folder-1.svg';
import { Link } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    textDecoration: 'none',
    '& .item-shortcut': {    
      backgroundRepeat: 'no-repeat',
      width: '250px',
      height: '250px',
      backgroundSize: 'contain',
      backgroundImage: `url(${Folder2})`,      
      cursor: 'pointer',
      
      // width: '250px',
      // height: '250px',
      // maskRepeat: 'no-repeat',
      // maskImage:`url(${Folder3})`,
      // maskSize: 'contain',
      // backgroundColor: '#fff',
      
      padding: '3.2em 2em',
  
      '& .title': {
        color: 'black',
        fontSize: '20px'
      },
      '& .description': {
        color: 'black',
        fontSize: '12px'
      },    
  
      '&:hover': {
        backgroundImage: `url(${Folder1})`,      
        color: '#1d78ce',
        fontSize: '#fff',
        '& .title': {
          color: '#ffffff',
        },
        '& .description': {
          color: '#ffffff',
        },    
      },      
    }
  }
}));


function MainItem(props) {  
  const classes = useStyles();
  const {title, description, to } = props;


  return (
    <Link to={to} className={classes.root}>
      <div className='item-shortcut'>      
        <div className='title'>{title}</div>
        <p className='description'>{description}</p>      
      </div>
    </Link>
  )
}

export default MainItem;